import React, { useState, useEffect } from 'react'
import styles from './profile-pic-editor-style.module.css';
import ProfilePicViewer from '../Account/ProfilePicViewer';

export default function ProfilePicEditor({profilePic, updateProfilePic, mouseCords, mouseDown, firstInitial}) {

    const [image, setImage] = useState();
    const fileSelected = (e) => {
        if (e.target.files) {
            let imageFile = e.target.files[0];
            var reader = new FileReader();
    
            reader.onload = (e) => { setImage(e.target.result); };
            reader.readAsDataURL(imageFile);
        }
    }
    const setProfilePic = (data) => {
        updateProfilePic(data);
        document.getElementById('file_chooser').value = "";
        document.getElementById('custom-color').value = data;
    }
    return (
        <div id={styles.profile_selector}>
            <div id={styles.type_selector}>
                <div id="initial-type-tab" className={`${styles.types} ${styles.selected}`} onClick={() => {
                    document.getElementById('file-type').classList.remove(styles.selected);
                    document.getElementById('initial-type').classList.add(styles.selected);
                    document.getElementById('file-type-tab').classList.remove(styles.selected);
                    document.getElementById('initial-type-tab').classList.add(styles.selected);
                }}>Initial</div>
                <div id="file-type-tab" className={styles.types} onClick={() => {
                    document.getElementById('file-type').classList.add(styles.selected);
                    document.getElementById('initial-type').classList.remove(styles.selected);
                    document.getElementById('file-type-tab').classList.add(styles.selected);
                    document.getElementById('initial-type-tab').classList.remove(styles.selected);
                }}>Image</div>
            </div>
            <div className={`${styles.type_panel}`} id='file-type'>
                <div id={styles.custom_image}>
                    <p>Custom Image:</p>
                    <label htmlFor='file_chooser' id={styles.upload_button}>Upload File</label>
                    <input type="file" id='file_chooser' name="file-chooser" accept="image/png, image/jpeg" onChange={(e) => fileSelected(e)} />
                    <ImageCropper image={image} updateProfilePic={updateProfilePic} mouseCords={mouseCords} mouseDown={mouseDown} />
                </div>
            </div>
            <div className={`${styles.type_panel} ${styles.selected}`} id='initial-type'>
                <div id={styles.custom_color}>
                    <p>Custom Color:</p>
                    <input id="custom-color" type="color" defaultValue={'#5C6C41'} onChange={(e) => {
                        setProfilePic(e.target.value);
                    }} />
                </div>
                <p>Chautauqua Colors: </p>
                <div className={styles.color_scale}>
                    <ColorSquare color={'#022529'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#044B52'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#06727C'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#0898A5'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#0BBECF'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#3BCBD8'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#6CD8E2'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#9DE5EB'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                </div>
                <div className={styles.color_scale}>
                    <ColorSquare color={'#242B19'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#495633'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#6F824E'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#94AD68'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#B9D982'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#C7E09B'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#D5E8B4'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#E3EFCD'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                </div>
                <div className={styles.color_scale}>
                    <ColorSquare color={'#202123'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#404347'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#60666A'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#80888E'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#A1AAB2'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#B3BBC1'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#C6CCD0'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                    <ColorSquare color={'#D9DDE0'} setProfilePic={setProfilePic} profilePic={profilePic}/>
                </div>
            </div>
            <div id={styles.preview}>
                <ProfilePicViewer profilePic={profilePic} firstInitial={firstInitial} size={64} />
            </div>
        </div>
    )
}

function ColorSquare({color, setProfilePic, profilePic}) {

    const [className, setClassName] = useState(styles.color_square);

    useEffect(() => {
        if(profilePic === color) {
            setClassName(`${styles.color_square} ${styles.selected_color}`);
        } else {
            setClassName(styles.color_square);
        }
    }, [profilePic]);

    return (
        <div id={`color-square-${color}`} className={className} style={{ backgroundColor: color }} onClick={() => setProfilePic(color)} />
    )
}

const IMAGE_SIZE = 128;
const HITBOX_SIZE = 30;

function ImageCropper({image, updateProfilePic, mouseCords, mouseDown}) {

    const [viewport, setViewport] = useState({x: 0, y: 0, w: 200, h: 200});
    const [size, setSize] = useState({w: 1000, h: 1000});
    const [focusedCorner, setFocusedCorner] = useState(null);
    const [touchState, setTouchState] = useState(false);

    const drawViewport = () => {
        const canvas = document.getElementById('canvas');
        if(canvas != null) {
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            ctx.fillStyle = '#FFFFFF50';

            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.clearRect(viewport.x, viewport.y, viewport.w, viewport.h);

            ctx.fillStyle = (focusedCorner?.corner === 'NW') ? '#F00' : '#FFF';
            ctx.fillRect(viewport.x, viewport.y, 10, 10);

            ctx.fillStyle = (focusedCorner?.corner === 'NE') ? '#F00' : '#FFF';
            ctx.fillRect(viewport.x + viewport.w - 10, viewport.y, 10, 10);

            ctx.fillStyle = (focusedCorner?.corner === 'SE') ? '#F00' : '#FFF';
            ctx.fillRect(viewport.x + viewport.w - 10, viewport.y + viewport.h - 10, 10, 10);

            ctx.fillStyle = (focusedCorner?.corner === 'SW') ? '#F00' : '#FFF';
            ctx.fillRect(viewport.x, viewport.y + viewport.h - 10, 10, 10);

            ctx.strokeStyle = '#FFF';
            ctx.lineWidth = 2;
            ctx.strokeRect(viewport.x, viewport.y, viewport.w, viewport.h);
        }
    };
    const getCroppedImage = (image, updateProfilePic, viewport) => {
        var imgDisplay = document.getElementById('image-cropper');
    
        var imgRender = document.createElement("img");
        imgRender.onload = () => {
            var canvas2 = document.createElement("canvas");
            var ctx2 = canvas2.getContext("2d");
            ctx2.canvas.height = IMAGE_SIZE;
            ctx2.canvas.width = IMAGE_SIZE;
    
            var selectionRatio = (IMAGE_SIZE / imgRender.width) * (imgDisplay.width / viewport.w);
            var scaleRatio = (imgRender.width / imgDisplay.width) * selectionRatio;
            
            ctx2.drawImage(imgRender, -viewport.x * scaleRatio, -viewport.y * scaleRatio, imgRender.width * selectionRatio, imgRender.height * selectionRatio);
    
            var dataurl = canvas2.toDataURL('png');
            updateProfilePic(dataurl);
        }
        imgRender.src = image;
    };
    const handleMouseMovement = (mouseX, mouseY) => {
        if(focusedCorner != null) {
            var adjustedViewport = {x: focusedCorner.viewport.x, y: focusedCorner.viewport.y, w: focusedCorner.viewport.w, h: focusedCorner.viewport.h};

            if (focusedCorner.corner === 'NW') {
                let distance = Math.min((mouseX - focusedCorner.mouseStartX), (mouseY - focusedCorner.mouseStartY));
                adjustedViewport.w -= distance;
                adjustedViewport.h -= distance;

                adjustedViewport.x += distance;
                adjustedViewport.y += distance;
            } else if (focusedCorner.corner === 'NE') {
                let distance = Math.min((mouseX - focusedCorner.mouseStartX), (focusedCorner.mouseStartY - mouseY));
                
                adjustedViewport.w += distance;
                adjustedViewport.h += distance;

                adjustedViewport.y -= distance;
            } else if (focusedCorner.corner === 'SE') {
                let distance = Math.min((mouseX - focusedCorner.mouseStartX), (mouseY - focusedCorner.mouseStartY));
                
                adjustedViewport.w += distance;
                adjustedViewport.h += distance;
            } else if (focusedCorner.corner === 'SW') {
                let distance = Math.min((focusedCorner.mouseStartX - mouseX), (mouseY - focusedCorner.mouseStartY));
                
                adjustedViewport.w += distance;
                adjustedViewport.h += distance;

                adjustedViewport.x -= distance;
            } else if (focusedCorner.corner === 'CENTER') {
                adjustedViewport.x += mouseX - focusedCorner.mouseStartX;
                adjustedViewport.y += mouseY - focusedCorner.mouseStartY;

                if(adjustedViewport.x < 0) {
                    adjustedViewport.x = 0;
                } else if (adjustedViewport.x + adjustedViewport.w > size.w) {
                    adjustedViewport.x = size.w - adjustedViewport.w;
                }

                if(adjustedViewport.y < 0) {
                    adjustedViewport.y = 0;
                } else if (adjustedViewport.y + adjustedViewport.h > size.h) {
                    adjustedViewport.y = size.h - adjustedViewport.h;
                }
            }

            if(adjustedViewport.w < 100 || adjustedViewport.h < 100) {
                adjustedViewport.w = 100;
                adjustedViewport.h = 100;
            }
                

            if(adjustedViewport.x < 0)
                adjustedViewport.x = 0;
            if(adjustedViewport.y < 0)
                adjustedViewport.y = 0;
            if(adjustedViewport.w + adjustedViewport.x > size.w) {
                adjustedViewport.w = size.w - adjustedViewport.x;
                adjustedViewport.h = size.w - adjustedViewport.x;
            }
            if(adjustedViewport.h + adjustedViewport.y > size.h) {
                adjustedViewport.w = size.h - adjustedViewport.y;
                adjustedViewport.h = size.h - adjustedViewport.y;
            }

            setViewport(adjustedViewport)
        }
    }

    useEffect(() => {
        const i = document.getElementById('image-cropper');
        i.onload = () => {
            setSize({w: i.width, h: i.height});
            const size = Math.min(i.width, i.height);
            setViewport({x: 0, y:0, w:size, h:size})
        }
        i.src = image;

        drawViewport();
    }, [image]);

    useEffect(() => {
        drawViewport();
        getCroppedImage(image, updateProfilePic, viewport);
    }, [viewport, focusedCorner]);

    useEffect(() => {
        const rect = document.getElementById('canvas').getBoundingClientRect();
        const mouseX = mouseCords.x - rect.x;
        const mouseY = mouseCords.y - rect.y - (window.pageYOffset || document.documentElement.scrollTop);
        handleMouseMovement(mouseX, mouseY);
    }, [mouseCords]);

    useEffect(() => {if(!mouseDown) setFocusedCorner(null);}, [mouseDown]);

    const onMouseDown = (e) => {
        // e.preventDefault();
        const rect = e.target.getBoundingClientRect()
        const clickX = e.clientX - rect.left;
        const clickY = e.clientY - rect.top;

        if(isNaN(clickX) || isNaN(clickY))
            return;

        const distanceNW = Math.sqrt(Math.pow(clickX - viewport.x, 2) +              Math.pow(clickY - viewport.y, 2));
        const distanceNE = Math.sqrt(Math.pow(clickX - viewport.x - viewport.w, 2) + Math.pow(clickY - viewport.y, 2));
        const distanceSW = Math.sqrt(Math.pow(clickX - viewport.x, 2) +              Math.pow(clickY - viewport.y - viewport.h, 2));
        const distanceSE = Math.sqrt(Math.pow(clickX - viewport.x - viewport.w, 2) + Math.pow(clickY - viewport.y - viewport.h, 2));

        if (distanceNW <= HITBOX_SIZE)
            setFocusedCorner({corner: 'NW', mouseStartX: clickX, mouseStartY: clickY, viewport: viewport});
        else if (distanceNE <= HITBOX_SIZE)
            setFocusedCorner({corner: 'NE', mouseStartX: clickX, mouseStartY: clickY, viewport: viewport});
        else if (distanceSW <= HITBOX_SIZE)
            setFocusedCorner({corner: 'SW', mouseStartX: clickX, mouseStartY: clickY, viewport: viewport});
        else if (distanceSE <= HITBOX_SIZE)
            setFocusedCorner({corner: 'SE', mouseStartX: clickX, mouseStartY: clickY, viewport: viewport});
        else if (clickX > viewport.x && clickX < viewport.x + viewport.w &&
                 clickY > viewport.y && clickY < viewport.y + viewport.h)
            setFocusedCorner({corner: 'CENTER', mouseStartX: clickX, mouseStartY: clickY, viewport: viewport});
        else if (focusedCorner != null)
            setFocusedCorner(null);
    }
    const onTouchMove = (e) => {
        if(touchState) {
            const rect = e.target.getBoundingClientRect();
            const mouseX = e.changedTouches[0].clientX - rect.x;
            const mouseY = e.changedTouches[0].clientY - rect.y;

            handleMouseMovement(mouseX, mouseY);
        } else {
            e.clientX = e.changedTouches[0].clientX;
            e.clientY = e.changedTouches[0].clientY;
            onMouseDown(e);
            setTouchState(true);
        }
    }

    return (
        <div id={styles.image_cropper}>
            <img id='image-cropper' src={image} style={{visibility: (image == null) ? 'hidden' : 'visible'}}/> 
            <canvas id='canvas' 
                                onTouchMove={(e) => onTouchMove(e)}
                                onTouchEnd={() => {setTouchState(false); setFocusedCorner(null);}}
                                onMouseDown={(e) => onMouseDown(e)}  
                                style={{display: 'block', touchAction: 'none', visibility: (image == null) ? 'hidden' : 'visible'}}
                                height={size.h} width={size.w}></canvas>     
        </div>
    )
}

